<template>
    <div class="partners-list-item">
        <img
            :src="item.img"
            :alt="item.name"
            class="partners-list-item__image"
        >
        <p class="partners-list-item__name">
            {{ item.name }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'PartnersListItem',
    props: ['item'],
}
</script>

<style lang="scss" scoped>
.partners-list-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #E9EBED;
    border-radius: 6px;
    padding: 40px 0;

    &__name {
        font-family: 'Montserrat';
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        color: #252425;
        margin-bottom: 0;
        @include mobile {
            font-size: 14px;
            line-height: 15px;
        }
    }

    &__image {
        display: block;
        max-width: 112px;
        margin-bottom: 54px;
        @include mobile {
            margin-bottom: 30px;
            max-width: 61px;
        }
    }
}
</style>